/** Offline grace period in seconds (7 days) */
export const OFFLINE_GRACE_SECONDS = 7 * 24 * 3600

/** Heartbeat interval in milliseconds (5 minutes) */
export const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000

interface JwtPayload {
  sub: string
  exp: number
  jti: string
  email: string
  role: string
}

/**
 * Decode a JWT payload without verification (client-side only).
 * Returns null if the token is malformed.
 */
export function parseToken(token: string): JwtPayload | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
    if (!payload.sub || !payload.exp || !payload.jti) return null
    return payload as JwtPayload
  } catch {
    return null
  }
}
